/* tslint:disable */
/* eslint-disable */
import { AbschnittDisplayModel as AceXFoundPortalCoreCaqModelsAbschnittDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model';
import { ProjektberichtDisplayModel as AceXFoundPortalCoreCaqModelsProjektberichtDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/projektbericht-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { AbschnittDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup } from '@/api/model-index';
import { ProjektberichtDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsProjektberichtDisplayModelFormGroup } from '@/api/model-index';

export interface IProjektberichtWithAbschnitteDisplayModel {
  abschnitteZwischenbericht?: null | Array<AceXFoundPortalCoreCaqModelsAbschnittDisplayModel>;
  projektberichte?: null | Array<AceXFoundPortalCoreCaqModelsProjektberichtDisplayModel>;
}
export class ProjektberichtWithAbschnitteDisplayModel extends BaseModel implements IProjektberichtWithAbschnitteDisplayModel {
  abschnitteZwischenbericht?: null | Array<AceXFoundPortalCoreCaqModelsAbschnittDisplayModel>;
  projektberichte?: null | Array<AceXFoundPortalCoreCaqModelsProjektberichtDisplayModel>;
}
class BaseProjektberichtWithAbschnitteDisplayModelFormGroup extends FormGroup {
  private static _instance: ProjektberichtWithAbschnitteDisplayModelFormGroup;
  
  public static get Instance(): ProjektberichtWithAbschnitteDisplayModelFormGroup {
    this._instance = new ProjektberichtWithAbschnitteDisplayModelFormGroup({
      abschnitteZwischenbericht: new FormArray([]),
      projektberichte: new FormArray([]),
    });

    return this._instance;
  }
}


export class ProjektberichtWithAbschnitteDisplayModelFormGroup extends BaseProjektberichtWithAbschnitteDisplayModelFormGroup {
  public get AbschnitteZwischenbericht(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup> {
    return this.controls["abschnitteZwischenbericht"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup>;
  }
  public get Projektberichte(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsProjektberichtDisplayModelFormGroup> {
    return this.controls["projektberichte"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsProjektberichtDisplayModelFormGroup>;
  }
  

}

export module ProjektberichtWithAbschnitteDisplayModelForm
  {
    export class FormFields
    {
      static _abschnitteZwischenbericht: string = "abschnitteZwischenbericht";
      static _projektberichte: string = "projektberichte";
    }
  }

